export const Bio = {
  name: "Digant Vyahalkar",
  roles: [
    "Full Stack Developer",
    "Software Developer",
    "Backend Developer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/digantv",
  resume:  
    "https://drive.google.com/file/d/18hDZdABgWColR-bjfnWsA_O-RINcbVBa/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/digant-vyahalkar-19471b22b/",
  twitter: "https://twitter.com/DVyahalkar/",
  insta: "https://www.instagram.com/digant_vyahalkar/",
  facebook: "https://www.facebook.com/digantvyahalkar3/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Java FX",
        image:
          "https://repository-images.githubusercontent.com/400161932/257a8be2-bbf2-4218-a55b-219d819578b2",
      },
      
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Spring Framework",
        image: "https://upload.wikimedia.org/wikipedia/commons/4/44/Spring_Framework_Logo_2018.svg",
      },
      {
        name: "Spring Boot",
        image:
          "https://vscjava.gallerycdn.vsassets.io/extensions/vscjava/vscode-spring-boot-dashboard/0.13.2023072200/1689984300042/Microsoft.VisualStudio.Services.Icons.Default",
      },
      {
        name: "Hibernate",
        image: "https://cdn.worldvectorlogo.com/logos/hibernate.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
     
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
      },
      {
        name:"Kafka",
        image:"https://logowik.com/content/uploads/images/kafka8040.jpg",
      },
      {
        name: "Grafana",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
      },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name:"Flutter",
        image:"https://w7.pngwing.com/pngs/537/866/png-transparent-flutter-hd-logo.png",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name:"Figma",
        image:"https://s3-alpha.figma.com/hub/file/2811018019/cae7d25d-8aff-4c49-8189-fad585dfb7cb-cover.png",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image:
          "https://w7.pngwing.com/pngs/968/991/png-transparent-google-colab-logo-tech-companies-thumbnail.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name:"Maven",
        image:"https://e7.pngegg.com/pngimages/917/651/png-clipart-apache-maven-feathers-tech-companies.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/D4D0BAQGwan_M1NV63Q/company-logo_200_200/0/1694263061323/codehop_logo?e=2147483647&v=beta&t=O4Nr7RwnLifB81CU2kj5muot6br76hIWJrZvu8DYgTw",
    role:"Intern Software Engineer",
    company: "Codehop",
    date: "Jan 2024 - Apr 2024",
    desc: "Enhanced user experiences on Spring, Springboot Portals by resolving bugs & reduced load time by 40%. Built Project Analytics portal using Spring Boot with seamless interaction of REST APIs. Modifying changes on server and testing the server using JUnit.",
    skills: [
      "Spring",
      "Spring Boot",
      "Agile Methodologies",
      "JUnit",
      "JSON Web Token(JWT)",
      "Swagger API",
      "Scrum",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
  {
    id: 1,
    img: "http://sgteksystems.com/images/onlinelogomaker-031422-1355-8048-2000-transparent1.png",
    role: "DevOps & Fullstack Engineering Intern",
    company: "SGTEK SYSYTEMS Pvt. Ltd.",
    date: "Jan 2024 - Present",
    desc: "Built Flipr Connect Platforms using React Js integrated GraphQL with AXIOS, created High level Design and Figma design. Built Backend with GraphQL and Node JS and connected with MongoDb - Reducing API calls by 20%. Dockerized and automated with Kubernetes & Jenkins CI/CD deployed in AWS-EC2 added Prometheus & Grafana for monitoring.",
    skills: [
      "Docker",
      "Terraform",
      "AWS",
      "EC2",
      "Portainer",
      "Nginx",
      "JavaScript",
      "TypeScript",
      "Node Js",
      " Next Js",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/D4D22AQG0G9OJgEJA1Q/feedshare-shrink_2048_1536/0/1692072730741?e=2147483647&v=beta&t=nZdSIuS3S0V4sFWsojZe9zBARdAMkxq1EnhgcfWIrcU",
    company: "InternPe",
    date: "Dec 2023 - Jan 2024",
    desc: "• Built RudraShakti - Astrologer App, with MVVM Architecture using Java and Android Studio integrating Firebase SDK. Created One to One video call integration with Socket.IO and Firebase cloud functions and integrated with Retrofit. Created Low Level Design and converted Figma design to XML code.",
    skills: [
      "Core Java",
      "AWT",
      "MySQL"
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  },
  {
    id: 3,
    img:"data:image/png;base64,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",
    company: "DevTown",
    date: "Nov 2023 - Jan 2024",
    desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
    skills: [
      "Volunteering",
      "Leadership",
      "Public speaking",
      "Networking",
      "Presentations",
      "Event Management"
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1691181448873.jpeg?alt=media&token=ee85eb8f-7247-43cd-9a1d-ce9f58ea62a6",
  },
];

export const education = [
  {
    id: 0,
    img: "https://lh3.googleusercontent.com/proxy/zuF97bJh4C7qmre5fDo0dcmGCC4FOvtI3u6RbGcYg5qVu8mrvihIZ5ZoLMf9bQgBNmFuRDbqc-uFN_wocj6n2i3CyJCqugA",
    school: "Savitribai Phule Pune University.",
    date: "Dec 2021 - Jul 2025",
    grade: "8.5 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Savitribai Phule Pune University. I have completed 5 semesters and have a CGPA of 7.5. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Engineering - BE, Computer Engineering",
  },
  {
    id: 1,
    img: "https://scontent.fpnq7-3.fna.fbcdn.net/v/t39.30808-6/311193550_420983753532143_1770552970510618223_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=5f2048&_nc_ohc=LeRi_SpAI1QAX9jT1n4&_nc_ht=scontent.fpnq7-3.fna&oh=00_AfDwMDZQWNLl4awmkNoMT1U7BOlyLakyIeSCsDRdNIkLYw&oe=65FBF416",
    school: "Dayanand Science Jr. College, Latur.",
    date: "Apr 2020 - Jul 2021",
    grade: "93.8%",
    desc: "I completed my class 12 high school education at Dayanand College, Latur, where I studied Science with Computer Science.",
    degree: "HSC(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://scontent.fpnq7-4.fna.fbcdn.net/v/t39.30808-6/301784200_420122846875797_1327788683338326198_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=5f2048&_nc_ohc=rwmaOLiAxDUAX-fTQFY&_nc_ht=scontent.fpnq7-4.fna&oh=00_AfDr3EsoDcWQYn1f5AE3uuyt_I7MmzASfxBKdcZBSs_wyA&oe=65FB07F8",
    school: "Shri Keshavraj High School, Latur.",
    date: "Apr 2018 - Apr 2019",
    grade: "87.80%",
    desc: "I completed my class 10 education at Shri Keshavraj High School, Latur, where I studied Science with Computer Application.",
    degree: "SSC(X)",
  },
];

export const projects = [

  {
    id: 0,
    title: "Podstream",
    date: "Apr 2023 - May 2023",
    description:
      "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
    image:
      "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    github: "https://github.com/rishavchanda/Podstream",
    webapp: "https://podstream.netlify.app/",
    member: [
      {
        name: "Digant Vyahalkar",
        img: "https://avatars.githubusercontent.com/u/64485885?v=4",
        linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
        github: "https://github.com/rishavchanda/",
      },
      {
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },
    ],
  },
  {
    id: 1,
    title: "Vexa",
    date: "Oct 2022 - Jan 2023",
    description:
      "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
    image:
      "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "web app",
    github: "https://github.com/rishavchanda/Project-Management-App",
    webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "Brain Tumor Detection",
    date: "Jan 2023 - Mar 2023",
    description:
      "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    image:
      "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "full stack app",
    github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    webapp: "https://brain-tumor.netlify.app/",
    member: [
      {
        name: "Rishav Chanda",
        img: "https://avatars.githubusercontent.com/u/64485885?v=4",
        linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
        github: "https://github.com/rishavchanda/",
      },
      {
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },
    ],
  },

];

